export default __webpack_public_path__ + "static/media/reset.26cf5341.svg";